
    import './styles.scoped.css';
    export default {
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_roh4h_98",
  "code-editor": "awsui_code-editor_1gl9c_roh4h_98",
  "pane": "awsui_pane_1gl9c_roh4h_662",
  "pane__close-container": "awsui_pane__close-container_1gl9c_roh4h_673",
  "pane__list": "awsui_pane__list_1gl9c_roh4h_678",
  "pane__table": "awsui_pane__table_1gl9c_roh4h_685",
  "pane__item": "awsui_pane__item_1gl9c_roh4h_690",
  "pane__cell": "awsui_pane__cell_1gl9c_roh4h_690",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_roh4h_704",
  "pane__location": "awsui_pane__location_1gl9c_roh4h_725",
  "pane__description": "awsui_pane__description_1gl9c_roh4h_725",
  "focus-lock": "awsui_focus-lock_1gl9c_roh4h_739",
  "editor": "awsui_editor_1gl9c_roh4h_786",
  "editor-refresh": "awsui_editor-refresh_1gl9c_roh4h_814",
  "status-bar": "awsui_status-bar_1gl9c_roh4h_819",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_roh4h_827",
  "status-bar__left": "awsui_status-bar__left_1gl9c_roh4h_831",
  "status-bar__left-virtual": "awsui_status-bar__left-virtual_1gl9c_roh4h_838",
  "status-bar__right": "awsui_status-bar__right_1gl9c_roh4h_842",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_roh4h_846",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_roh4h_846",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_roh4h_851",
  "status-bar-virtual": "awsui_status-bar-virtual_1gl9c_roh4h_855",
  "tab-button": "awsui_tab-button_1gl9c_roh4h_861",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_roh4h_889",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_roh4h_892",
  "tab-button--active": "awsui_tab-button--active_1gl9c_roh4h_901",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_roh4h_917",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_roh4h_947",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_roh4h_954",
  "loading-screen": "awsui_loading-screen_1gl9c_roh4h_958",
  "error-screen": "awsui_error-screen_1gl9c_roh4h_959"
};
  